import { render, staticRenderFns } from "./PizzaIcon.vue?vue&type=template&id=7eeff810&"
import script from "./PizzaIcon.vue?vue&type=script&lang=ts&"
export * from "./PizzaIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PizzaIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PizzaIcon.vue"
export default component.exports